import { BigNumber } from 'bignumber.js';
import { formatParts, format, formatPartsToString, } from './numeric-format-base.js';
export const findRule = (input, rules) => {
    for (const rule of rules) {
        const bnInput = BigNumber(input);
        if (rule.exact && bnInput.eq(rule.exact)) {
            return rule;
        }
        if (rule.upperBound !== undefined &&
            bnInput.abs().isLessThan(rule.upperBound)) {
            return rule;
        }
    }
};
export const formatRuleToParts = (input, rule, options) => {
    const bnInput = BigNumber(input);
    const mergedOptions = {
        ...('options' in rule ? rule.options : {}),
        ...options,
        ...(bnInput.isZero() ? { forceSign: false } : {}),
    };
    if ('format' in rule) {
        return rule.format(bnInput);
    }
    if (rule.rewriteInput) {
        return formatParts(rule.rewriteInput, mergedOptions);
    }
    return formatParts(bnInput, mergedOptions);
};
export const formatRule = (input, rule, options) => {
    const bnInput = BigNumber(input);
    const mergedOptions = {
        ...('options' in rule ? rule.options : {}),
        ...options,
    };
    if ('format' in rule) {
        return formatPartsToString(rule.format(bnInput));
    }
    if (rule.rewriteInput) {
        return format(rule.rewriteInput, mergedOptions);
    }
    return format(bnInput, mergedOptions);
};
//# sourceMappingURL=numeric-format-rule.js.map